export default __webpack_public_path__ + "static/media/deleted.c22fe28e.svg";